(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["melden-home-nav"] && !Shopify.designMode) return;
  try {
    document.addEventListener('keydown',function(event){
  if(event.key!=='Escape')return;
  const menu=event.target.closest('.mhn');
  if(!menu)return;
  const current=event.target.closest('details[open]');
  if(current){current.open=false;current.querySelector('summary').focus();}
});
document.addEventListener('click',function(event){
  document.querySelectorAll('.mhn:not(.mhn-mobile)>li>details[open]').forEach(function(menu){
    if(!menu.contains(event.target))menu.open=false;
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["melden-ring-sizer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('melden-ring-sizer')) {
class MeldenRingSizer extends HTMLElement {
  connectedCallback() {
    if (this.ready) {window.addEventListener('resize',this.onResize);window.visualViewport?.addEventListener('resize',this.onResize);return;}
    this.ready = true;
    this.$ = selector => this.querySelector(selector);
    this.dialog = this.$('dialog');
    this.table = [14.1,14.5,14.9,15.3,15.7,16.1,16.5,16.9,17.3,17.7,18.1,18.5,19.0,19.4,19.8,20.2,20.6,21.0,21.4,21.8,22.2,22.6].map((d,i) => ({d, size:3+i/2}));
    this.table.forEach(row => {
      const tr = document.createElement('tr');
      [row.size,row.d.toFixed(1)].forEach(value => {const td=document.createElement('td');td.textContent=value;tr.append(td);});
      this.$('[data-chart]').append(tr);
    });
    this.method='ring';this.calibrated=false;
    this.addEventListener('click',event => {
      const button=event.target.closest('button');if(!button)return;
      if(button.hasAttribute('data-open')){this.dialog.showModal();this.checkScale();}
      if(button.hasAttribute('data-close'))this.dialog.close();
      if(button.dataset.method)this.setMethod(button.dataset.method);
      if(button.hasAttribute('data-confirm')){
        this.ppm=Number(this.$('[data-cal]').value)/54;
        this.calibrated=true;this.signature=this.scaleSignature();this.show('measure');this.drawRing();
      }
      if(button.hasAttribute('data-reset')){this.calibrated=false;this.show('calibrate');}
      if(button.hasAttribute('data-restart'))this.setMethod('ring');
      if(button.hasAttribute('data-result')){
        this.checkScale();if(this.calibrated)this.result(Number(this.$('[data-diameter]').value));
      }
      if(button.hasAttribute('data-manual-result')){
        const value=Number(this.$('[data-manual]').value);
        if(!Number.isFinite(value)||value<44.3||value>71){this.status('invalid');this.$('[data-manual]').focus();return;}
        this.result(value/Math.PI);
      }
    });
    this.addEventListener('keydown',event => {
      if(event.key==='Enter' && event.target.matches('input')) {
        event.preventDefault();event.stopPropagation();
        if(event.target.hasAttribute('data-manual')) this.$('[data-manual-result]').click();
      }
    });
    this.$('[data-cal]').addEventListener('input',()=>{this.$('.mrs-cal-line').style.height=this.$('[data-cal]').value+'px';});
    this.$('[data-diameter]').addEventListener('input',()=>this.drawRing());
    this.$('[data-manual]').addEventListener('input',()=>this.status());
    this.dialog.addEventListener('close',()=>this.$('[data-open]').focus());
    this.onResize=()=>this.checkScale();
    window.addEventListener('resize',this.onResize);
    window.visualViewport?.addEventListener('resize',this.onResize);
  }
  disconnectedCallback(){window.removeEventListener('resize',this.onResize);window.visualViewport?.removeEventListener('resize',this.onResize);}
  scaleSignature(){return [window.innerWidth,window.devicePixelRatio,window.visualViewport?.scale||1].join(':');}
  checkScale(){if(this.calibrated&&this.signature!==this.scaleSignature()){this.calibrated=false;if(this.method==='ring'){this.show('calibrate');this.status('resize');}}}
  status(key){this.$('[data-status]').textContent=key?this.$('[data-'+key+']').textContent:'';}
  show(panel){this.querySelectorAll('[data-panel]').forEach(el=>el.hidden=el.dataset.panel!==panel);this.status();this.dialog.scrollTop=0;}
  setMethod(method){this.method=method;this.querySelectorAll('[data-method]').forEach(el=>el.setAttribute('aria-pressed',String(el.dataset.method===method)));this.show(method==='manual'?'manual':this.calibrated?'measure':'calibrate');this.checkScale();if(this.calibrated)this.drawRing();}
  drawRing(){const d=Number(this.$('[data-diameter]').value);this.$('.mrs-circle').style.width=d*this.ppm+'px';this.$('.mrs-circle').style.height=d*this.ppm+'px';this.$('[data-diameter-output]').textContent=d.toFixed(2);}
  result(d){
    if(d<14.0||d>22.7){this.status('range');return;}
    const row=this.table.reduce((best,current)=>Math.abs(current.d-d)<=Math.abs(best.d-d)+1e-9?current:best);
    this.$('[data-size]').textContent=row.size;
    this.$('[data-dimensions]').textContent=d.toFixed(2)+' mm / '+(d*Math.PI).toFixed(1)+' mm';
    this.show('result');const title=this.$('.mrs-result');title.tabIndex=-1;title.focus();
  }
}
customElements.define('melden-ring-sizer',MeldenRingSizer);
}
  } catch(e) { console.error(e); }
})();

})();
